import { FootchinkoItem } from "./FootchinkoItem";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";

    export class SolidPlank extends FootchinkoItem {

        constructor(game: Phaser.Game, x: number, y: number, rotation: number) {

            super ( game, x, y, "texture_atlas_1", true, false, rotation);

            this.canBeHit = true;
        }

        public setBody(): void {

            // definir el cuerpo
            this.body.setRectangle(68, 28, 0, 2 ); 
            this.body.rotation = this.itemRotation;
            this.body.mass = 10e8;
            this.body.static = true;
            this.body.setMaterial( GameVars.getInstance().materials.plankMaterial);
        }

        public setView(): void {

            super.setView();

            this.name = GameConstants.SOLID_PLANK;
            this.burntFrameName = "burnt-plank";
            this.frameName = "solid-plank";
        }

        public hit(): void {
            AudioManager.getInstance().playEffect("madera_solida_1");
        }
    }
